import { render } from "./ListarComprobantesNT.vue?vue&type=template&id=23c99cef"
import script from "./ListarComprobantesNT.vue?vue&type=script&lang=js"
export * from "./ListarComprobantesNT.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__